<!-- Hero Section -->
<section class="hero-section">
    <div class="page-title-area">
        <div class="container">
            <div class="hero-content">
                <img src="assets/images/imac/hero.png" alt="iMac" class="hero-image">
                <p class="gradient-text">Built for Apple Intelligence</p>
            </div>
        </div>
    </div>
</section>

<!-- Features Section -->
<div class="features-section">
    <div class="container">
        <!-- Display Feature -->
        <div class="row mb-5">
            <div class="col-12">
                <div class="feature-card display-info-card">
                    <div class="text-content">
                        <h1>Display.</h1>
                        <h2>A real pupil‑pleaser.</h2>
                        <p>With an expansive 24‑inch Retina display, iMac offers a brilliant canvas for multitasking, immersive movies and games, and more. The 4.5K resolution and 500 nits of brightness deliver crisp, clear details — that's five times the resolution and nearly 70 percent brighter compared with the best-selling 24‑inch all‑in‑one PC. And P3 wide color brings whatever's onscreen to life with over a billion colors.</p>
                    </div>
                    <img src="assets/images/imac/display.jpg" alt="iMac Display" class="display-image">
                </div>
            </div>
        </div>

        <!-- Colors and AI Section -->
        <div class="row mt-5">
            <div class="col-md-6">
                <div class="feature-card colors-card" style="background-image: url('assets/images/imac/color.png');">
                    <div class="text-content">
                        <h2>Seven vibrant colors</h2>
                        <p>Blue • Green • Pink • Silver • Yellow • Orange • Purple</p>
                    </div>
                </div>
            </div>
            <div class="col-md-6">
                <div class="feature-card ai-card">
                    <div class="ai-content">
                        <h2 class="gradient-title">Apple Intelligence.</h2>
                        <h3 class="ai-subtitle">A breath of fresh AI.</h3>
                        <p class="ai-description">Apple Intelligence is the personal intelligence system that helps you write, express yourself, and get things done effortlessly. With groundbreaking privacy protections, it gives you peace of mind that no one else can access your data — not even Apple.</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Lifestyle Section -->
        <div class="row mt-5">
            <div class="col-12">
                <div class="feature-card lifestyle-card" style="background-image: url('assets/images/imac/lifestyle.jpg');">
                    <div class="text-content">
                        <h2>Fits perfectly into your lifestyle.</h2>
                        <p>Whether you're working, creating, or connecting with family, iMac seamlessly integrates into your daily life with its stunning design and powerful capabilities.</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Performance Comparison Section -->
        <div class="row mt-5">
            <div class="col-12">
                <div class="feature-card performance-card">
                    <div class="performance-grid">
                        <div class="m4-icon">
                            <img src="assets/images/imac/m4.png" alt="M4 Chip">
                        </div>
                        <div class="performance-stats">
                            <div class="stat-item">
                                <h3>Up to 6x faster</h3>
                                <p>than the most popular Intel-based iMac<sup>2</sup></p>
                            </div>
                            <div class="stat-item">
                                <h3>Up to 2.1x faster</h3>
                                <p>than iMac with M1 chip on demanding creative workflows<sup>3</sup></p>
                            </div>
                            <div class="stat-item">
                                <h3>Up to 4.5x faster</h3>
                                <p>than the most popular Windows all‑in‑one<sup>4</sup></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Thunderbolt Feature -->
        <div class="row mb-5">
            <div class="col-12">
                <div class="feature-card thunderbolt-card" style="background-image: url('assets/images/imac/ports.jpg');">
                    <div class="text-content">
                        <h2>Powerful ports. More possibilities.</h2>
                        <p>iMac now features up to four Thunderbolt 4 ports — expanding your accessory options and enabling lightning-fast data transfers. And you can connect up to two external 6K displays for a vast canvas to view your work.</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Additional Features Grid -->
        <div class="row">
            <div class="col-12">
                <div class="feature-card connectivity-card">
                    <div class="features-grid">
                        <div class="feature-item">
                            <img src="assets/images/imac/icon_wifi.png" alt="Wi-Fi 6">
                            <h3>Wi-Fi 6</h3>
                            <p>Superfast wireless connections for streaming and sharing.</p>
                        </div>
                        <div class="feature-item">
                            <img src="assets/images/imac/icon_display.png" alt="Magic Keyboard">
                            <h3>Magic Keyboard</h3>
                            <p>Color-matched keyboard with Touch ID for secure authentication.</p>
                        </div>
                        <div class="feature-item">
                            <img src="assets/images/imac/icon_lightning.png" alt="Thunderbolt">
                            <h3>Thunderbolt ports</h3>
                            <p>Connect to external displays and high-performance devices.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Accessories Section -->
        <div class="row mt-5">
            <div class="col-12">
                <div class="feature-card accessories-card">
                    <div class="accessories-content">
                        <h2>Accessories.</h2>
                        <h3>Deck out your desk.</h3>
                        <p>iMac features a color-matched keyboard</p>
                    </div>
                    <img src="assets/images/imac/keyboard.jpg" alt="iMac Accessories" class="accessories-image">
                </div>
            </div>
        </div>

        
    </div>
</div>
